import { existsSync, mkdirSync, readFileSync, writeFileSync } from 'node:fs';
import { dirname } from 'node:path';
import type { VectorRecord } from '@fim/futurex-vector';
import type { FileImports } from './imports.js';
import type { SymbolDef } from './symbols.js';
import type { Chunk } from './types.js';

// v2 added the AST symbol table; v3 added the import graph. An older index fails to
// load → forces a clean rebuild rather than silently running without them.
const VERSION = 3;

export interface PersistedIndex {
  version: number;
  /** Embedder id the records were built with — retrieval MUST use a matching embedder. */
  embedderId: string;
  dimensions: number;
  root: string;
  createdAt: string;
  records: VectorRecord<Chunk>[];
  /** AST symbol table (§3.5). */
  symbols: SymbolDef[];
  /** Import graph (advanced code understanding). */
  imports: FileImports[];
}

export function saveIndex(path: string, data: Omit<PersistedIndex, 'version'>): void {
  mkdirSync(dirname(path), { recursive: true });
  writeFileSync(path, JSON.stringify({ version: VERSION, ...data }), { mode: 0o600 });
}

export function loadIndex(path: string): PersistedIndex | null {
  if (!existsSync(path)) return null;
  try {
    const parsed = JSON.parse(readFileSync(path, 'utf8')) as PersistedIndex;
    return parsed.version === VERSION ? parsed : null;
  } catch {
    return null;
  }
}
